import React from "react";
import { Spinner } from "react-bootstrap";
const ProgressIndicator = (props) => {
  return (
    <>
      {props.isLoading && (
        <div className="progress-indicator bg-light d-flex align-items-center text-muted">
          <Spinner animation="border" size="sm" />
          <p className="ml-2 mb-0">Enviando</p>
        </div>
      )}
    </>
  );
};

export default ProgressIndicator;
